import {
    Box,
    Typography
} from "@material-ui/core";
import {useEffect, useMemo, useState} from "react";
import moment from "moment";

const TestTimer = ({ timeLimit, handleTimeFinish, startedAt, durationInMinutes }) => {
    const [timeLeft, setTimeLeft] = useState(null);

    const limit = useMemo(() => {
        return moment(startedAt).add(durationInMinutes, 'minutes');
    }, [durationInMinutes, startedAt]);
    
    const pending = useMemo(() => {
        return moment(limit).diff(moment.now(), 'second');
    }, [durationInMinutes, limit])


    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
    };

    
    useEffect(() => {
        if (timeLeft !== null) {
            const timer = setInterval(() => {
                setTimeLeft((prevTime) => {
                    if (prevTime <= 1) {
                        clearInterval(timer);
                        handleTimeFinish(true)
                        return 0;
                    }
                    return prevTime - 1;
                });
            }, 1000);
            return () => clearInterval(timer);
        } else {
            setTimeLeft(pending)
        }
    }, [timeLeft, handleTimeFinish, pending]);

    return (
        <Box textAlign="right" marginBottom="1rem">
            <Typography variant="h6" color="secondary">
                Tempo restante: {formatTime(timeLeft)}
            </Typography>
        </Box>
    )
}

export default TestTimer;